import { render } from "./WaitingList.vue?vue&type=template&id=2dd0b379"
import script from "./WaitingList.vue?vue&type=script&lang=js"
export * from "./WaitingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__